import { formatThousands } from '@wwe-portal/utils/format';

export const diagramConfig = (datasets, snapShotMonth) => {
  return {
    type: 'bar',
    data: {
      labels: snapShotMonth || [
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'July',
      ],
      datasets: datasets,
    },
    options: {
      legend: {
        display: false,
      },
      cornerRadius: 20,
      scales: {
        xAxes: [
          {
            gridLines: {
              display: false,
            },
            stacked: true,
            ticks: {
              fontColor: '#4f5794',
              fontSize: 14,
              beginAtZero: true,
            },
            barPercentage: 0.3,
          },
        ],
        yAxes: [
          {
            stacked: true,
            gridLines: {
              offsetGridLines: false,
              display: true,
              borderDash: [6, 2],
              tickMarkLength: 5,
              color: '#343961',
              zeroLineWidth: 0,
            },
            ticks: {
              beginAtZero: false,
              fontColor: '#4f5794',
              fontSize: 14,
              callback: function (value) {
                return formatThousands(value);
              },
            },
          },
        ],
      },
    },
  };
};
